import React from 'react';
import { TableConfig } from '../../../../../v2BaseComponents/RichTable/types';
import { getIntl } from '../../../../../../utils/intl';
import { useRichTableState } from '../../../../../v2BaseComponents/RichTable/useRichTableState';
import RichTable from '../../../../../v2BaseComponents/RichTable';
import getDateString from '../../../../../../utils/getDateString';
import { EntityAuditLogListItem } from '../../../../../../primary-record-types/apiTypes/organizationService';
import Text from '../../../../../v2BaseComponents/Text';
import { getOrgEntityAuditLogEventDisplayNameWithFallback } from '../../../../../../utils/resourceUtils/getEntityAuditLogEventName';
import getName from '../../../../../../utils/getName';

const intl = getIntl('resources-root-screen-administration-logs-tab-table', {
    title: 'Adminstration Logs',
    event: 'Event',
    user: 'User',
    time: 'Time',
    details: 'Details',
});

export type AdministrationLogsTableOwnProps = {
    isLoading: boolean;
    auditLogs: EntityAuditLogListItem[] | undefined;
};

export type AdministrationLogsTableProps = AdministrationLogsTableOwnProps;
type TableItem = EntityAuditLogListItem;

const AdministrationLogsTable: React.FC<AdministrationLogsTableProps> = (props) => {
    const [tableState, setTableState] = useRichTableState();

    const getEvent = (adminLogItem: TableItem) => getOrgEntityAuditLogEventDisplayNameWithFallback(adminLogItem.type);
    const getTime = (adminLogItem: TableItem) => getDateString(adminLogItem.timestamp, 'date-time-seconds');
    const getUser = (adminLogItem: TableItem) => {
        const userRef = (adminLogItem.references as any).user;
        const actingUserReference = Array.isArray(userRef) ? userRef[0].references : userRef?.references;
        return getName(actingUserReference);
    };
    const getDetails = (adminLogItem: TableItem) => adminLogItem.auditLogDetails;

    const AdministrationLogsTableConfig: TableConfig<TableItem> = {
        columns: [
            {
                label: intl('event'),
                columnKey: 'event',
                getSortValue: getEvent,
                getContentKey: getEvent,
                getSearchValue: getEvent,
                getDiscreetValue: getEvent,
                render: getEvent,
            },
            {
                label: intl('time'),
                columnKey: 'time',
                getSortValue: getTime,
                getContentKey: getTime,
                getSearchValue: getTime,
                render: getTime,
            },
            {
                label: intl('user'),
                columnKey: 'user',
                getSortValue: getUser,
                getContentKey: getUser,
                getSearchValue: getUser,
                getDiscreetValue: getUser,
                render: getUser,
            },
            {
                label: intl('details'),
                columnKey: 'details',
                getSortValue: getDetails,
                getContentKey: getDetails,
                getSearchValue: getDetails,
                render: getDetails,
            },
        ],
        getRowKey: (item) => item.auditLogId,
    };

    return (
        <>
            <Text variant="bold-h4" style={{ padding: 12 }}>
                {intl('title')}
            </Text>
            <RichTable
                config={AdministrationLogsTableConfig}
                state={tableState}
                onStateChange={setTableState}
                data={props.auditLogs!}
                minWidth={'100%'}
                style={{ height: '100%' }}
                isFetching={props.isLoading}
                actions={[]}
                testID="administration-log-table"
            />
        </>
    );
};

export default React.memo(AdministrationLogsTable);
